// Primitive design tokens — surowe wartości bazowe.
// Zgodnie z .windsurf/docs/Engagement_Challenges_UI_Design_Direction_v1.md (sekcja 5, 6, 9).
// Nie używać tych wartości bezpośrednio w komponentach — korzystać z warstwy semantic/.

export const color = {
  brand: {
    50: '#F2F0FF',
    100: '#E4DFFF',
    300: '#AFA0FF',
    500: '#6D55F7',
    600: '#5840DB',
    700: '#452FBA',
  },
  energy: {
    300: '#B9F36B',
    400: '#9DE94B',
    600: '#5D9F20',
  },
  warm: {
    300: '#FFB36B',
    500: '#F47B35',
  },
  neutralLight: {
    ink: '#17151F',
    inkSoft: '#4F4A59',
    muted: '#77717F',
    line: '#E4E0E8',
    surface: '#FFFFFF',
    canvas: '#F7F6F3',
    elevated: '#FCFBFF',
  },
  neutralDark: {
    ink: '#F5F2F8',
    inkSoft: '#CAC4D1',
    muted: '#9E97A7',
    line: '#36313C',
    surface: '#17151B',
    canvas: '#111014',
    elevated: '#211E27',
  },
  semantic: {
    positive: '#17845B',
    warning: '#A96400',
    danger: '#C53D4B',
    info: '#286DB5',
  },
};

export const spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
};

export const radius = {
  control: 12,
  card: 20,
  hero: 30,
  pill: 999,
};

export const typography = {
  fontFamilyDisplay: '"Manrope Variable", "Manrope", "Plus Jakarta Sans", sans-serif',
  fontFamilyUI: '"Inter Variable", "Inter", "Segoe UI", sans-serif',
  scale: {
    displayXl: { fontSize: '3.5rem', lineHeight: '3.5rem', fontWeight: 750, letterSpacing: '-0.03em' },
    displayMd: { fontSize: '2.75rem', lineHeight: '3rem', fontWeight: 720, letterSpacing: '-0.025em' },
    headingXl: { fontSize: '2rem', lineHeight: '2.375rem', fontWeight: 700, letterSpacing: '-0.02em' },
    headingMd: { fontSize: '1.375rem', lineHeight: '1.75rem', fontWeight: 680, letterSpacing: '-0.015em' },
    bodyLg: { fontSize: '1rem', lineHeight: '1.5rem', fontWeight: 450, letterSpacing: '0' },
    bodyMd: { fontSize: '0.875rem', lineHeight: '1.3125rem', fontWeight: 450, letterSpacing: '0' },
    label: { fontSize: '0.8125rem', lineHeight: '1rem', fontWeight: 650, letterSpacing: '0' },
    micro: { fontSize: '0.6875rem', lineHeight: '0.875rem', fontWeight: 600, letterSpacing: '0.02em' },
  },
};

export const motion = {
  duration: {
    instant: 90,
    fast: 160,
    standard: 240,
    emphasis: 420,
  },
  easing: {
    standard: 'cubic-bezier(0.2, 0, 0, 1)',
    emphasis: 'cubic-bezier(0.2, 0.8, 0.2, 1)',
    exit: 'cubic-bezier(0.4, 0, 1, 1)',
  },
};

export const shadow = {
  float: '0 12px 36px rgba(29, 21, 49, 0.14)',
  soft: '0 4px 16px rgba(29, 21, 49, 0.07)',
  borderSubtle: '1px solid rgba(48, 40, 62, 0.10)',
};
